<template>
  <v-app-bar
    v-if="$route.name !== 'login'"
    app
    color="white"
    clipped-right
    clipped-left
    flat
    class="elevation-1"
  >
    <!-- Logo -->
    <v-img
      style="cursor:pointer"
      @click="goToPage('/')"
      contain
      max-height="60"
      max-width="100"
      src="@/assets/complete_logo.png"
      class="mr-3"
    />

    <!-- Menú móvil (pantallas pequeñas) -->
    <v-menu v-if="$vuetify.breakpoint.smAndDown" offset-y>
      <template v-slot:activator="{ on, attrs }">
        <v-btn icon v-bind="attrs" v-on="on" class="mr-2">
          <v-icon>mdi-dots-vertical</v-icon>
        </v-btn>
      </template>
      <v-list dense class="pa-0">
        <!-- Generación dinámica de items permitidos -->
        <v-list-item
          v-for="item in menuItems"
          :key="item.routeName"
          :to="{ name: item.routeName }"
          exact
          active-class="primary--text grey lighten-4"
        >
          <v-list-item-title>{{ item.text }}</v-list-item-title>
        </v-list-item>

        <v-divider></v-divider>
        <v-list-item style="background-color: #117f9c; color: white" @click="logoutFromApp">
          <v-list-item-title>Cerrar Sesión</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>

    <!-- Pestañas Desktop (Vinculadas a rutas) -->
    <v-tabs v-else optional color="primary" class="ml-2" slider-color="primary">
      <v-tab
        v-for="item in menuItems"
        :key="item.routeName"
        :to="{ name: item.routeName }"
        class="font-weight-bold"
        :exact="item.routeName !== 'mantenimiento'"
      >
        {{ item.text }}
      </v-tab>
    </v-tabs>

    <v-spacer></v-spacer>

    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn icon v-bind="attrs" v-on="on" @click="openPasswordDialog = true" class="mx-1">
          <v-icon>mdi-lock-reset</v-icon>
        </v-btn>
      </template>
      <span>Cambiar contraseña</span>
    </v-tooltip>
    
    <!-- Botón: Administrar usuarios -->
    <v-tooltip v-if="puedeAdministrarUsuarios" bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn icon v-bind="attrs" v-on="on" @click="goToPage('register')" class="mx-1">
          <v-icon>mdi-account</v-icon>
        </v-btn>
      </template>
      <span>Administrar usuarios</span>
    </v-tooltip>

    <!-- Botón: Cesta -->
    <v-tooltip v-if="rolPermitido('articles')" bottom>
      <template v-slot:activator="{ on: onTooltip }">
        <v-menu offset-y left min-width="320" max-width="350" :close-on-content-click="false">
          <template v-slot:activator="{ on: onMenu }">
            <v-badge bordered color="primary" overlap :content="badgeContent" :value="badgeContent > 0" class="mx-3">
              <v-btn fab x-small elevation="1" v-on="{ ...onTooltip, ...onMenu }">
                <v-icon color="secondary">mdi-cart</v-icon>
              </v-btn>
            </v-badge>
          </template>

          <v-card>
            <v-toolbar color="primary" dark dense flat>
              <v-toolbar-title class="body-1">Mi Carrito</v-toolbar-title>
            </v-toolbar>
            <v-list dense max-height="400" class="overflow-y-auto">
              <v-list-item v-if="articlesInCart().length === 0">
                <v-list-item-content>
                  <v-list-item-title class="text-center grey--text">Cesta vacía</v-list-item-title>
                </v-list-item-content>
              </v-list-item>

              <v-list-item v-for="item in articlesInCart()" :key="item.id">
                <v-list-item-avatar tile size="40">
                  <v-img :src="item.image_1920 || ''">
                    <template v-slot:placeholder>
                      <v-icon color="grey lighten-2">mdi-package-variant</v-icon>
                    </template>
                  </v-img>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title class="font-weight-bold text-truncate" style="max-width: 150px;">{{ item.name }}</v-list-item-title>
                  <v-list-item-subtitle class="caption primary--text">Cantidad: {{ item.quantity }}</v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action>
                  <v-btn icon small @click.stop="removeFromCart(item)">
                    <v-icon small color="red lighten-2">mdi-delete</v-icon>
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
            </v-list>
            <v-divider></v-divider>
            <v-card-actions v-if="articlesInCart().length > 0">
              <v-btn block color="primary" depressed @click="goToPage('shopping-cart')">
                Procesar Pedido
                <v-icon right small>mdi-arrow-right</v-icon>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-menu>
      </template>
      <span>Ver Cesta</span>
    </v-tooltip>

    <!-- Botón: Cerrar sesión -->
    <v-tooltip v-if="!$vuetify.breakpoint.smAndDown" bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn icon v-bind="attrs" v-on="on" @click="logoutFromApp" class="mx-1">
          <v-icon>mdi-logout</v-icon>
        </v-btn>
      </template>
      <span>Cerrar Sesión</span>
    </v-tooltip>

    <!-- Dialog para Cambiar Contraseña -->
    <v-dialog v-model="openPasswordDialog" max-width="450px" transition="dialog-bottom-transition">
      <v-card elevation="16" class="rounded-lg">
        <v-toolbar color="primary" dark flat>
          <v-icon class="mr-3">mdi-lock-reset</v-icon>
          <v-toolbar-title class="font-weight-light">Actualizar Contraseña</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="openPasswordDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
  
        <v-card-text class="pt-6">
          <v-form ref="passwordForm" v-model="isFormValid" lazy-validation>
            
            <!-- Contraseña Actual -->
            <v-text-field
              id="password"
              name="psw"
              v-model="passwordData.oldPassword"
              label="Contraseña Actual"
              :append-icon="showPass1 ? 'mdi-eye' : 'mdi-eye-off'"
              :type="showPass1 ? 'text' : 'password'"
              @click:append="showPass1 = !showPass1"
              outlined
              dense
              prepend-inner-icon="mdi-lock-open-outline"
              :rules="[v => !!v || 'La contraseña actual es obligatoria']"
            ></v-text-field>
  
            <v-divider class="my-4"></v-divider>
  
            <!-- Nueva Contraseña -->
            <v-text-field
              v-model="passwordData.newPassword"
              label="Nueva Contraseña"
              :append-icon="showPass2 ? 'mdi-eye' : 'mdi-eye-off'"
              :type="showPass2 ? 'text' : 'password'"
              @click:append="showPass2 = !showPass2"
              outlined
              dense
              prepend-inner-icon="mdi-lock-plus"
              persistent-hint
            ></v-text-field>
  
            <!-- Confirmar Nueva Contraseña -->
            <v-text-field
              v-model="passwordData.confirmPassword"
              label="Confirmar Nueva Contraseña"
              :type="showPass2 ? 'text' : 'password'"
              outlined
              dense
              class="mt-4"
              prepend-inner-icon="mdi-lock-check"
              :rules="[
                v => !!v || 'Confirme su contraseña',
                v => v === passwordData.newPassword || 'Las contraseñas no coinciden'
              ]"
            ></v-text-field>
          </v-form>
        </v-card-text>
  
        <v-card-actions class="pb-6 px-6">
          <v-btn text color="grey darken-1" @click="closePasswordDialog">
            Cancelar
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn 
            color="primary" 
            elevation="2" 
            :disabled="!isFormValid" 
            :loading="loading"
            @click="updatePassword"
          >
            Guardar Cambios
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app-bar>

</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";

export default {
  name: "SuperiorMenu",
  data() {
    return {
      openPasswordDialog: false,
      isFormValid: false,
      loading: false,
      showPass1: false,
      showPass2: false,
      passwordData: {
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
      },
    }
  },
  computed: {
    ...mapState(["esRamos", "permisos"]),

    // Centralizamos la lógica del menú para que móvil y desktop sean idénticos
    menuItems() {
      return [
        { text: 'ARMARIOS', routeName: 'cabinets' }
      ];
    },

    puedeAdministrarUsuarios() {
      return this.permisos.includes('admin-users');
    },

    badgeContent() {
      return this.articlesInCart().length;
    },
  },
  methods: {
    ...mapGetters(["articlesInCart"]),
    ...mapActions(["postDataWithReturn"]),

    closePasswordDialog() {
      this.openPasswordDialog = false;
      this.passwordData = {
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
      };
    },
    async updatePassword() {
      // 1. Forzamos la validación manual
      const isValid = this.$refs.passwordForm.validate();
      
      if (isValid) {
        this.loading = true;
        
        // Crea una copia de los datos para el log (así te aseguras de ver lo que hay en ese instante)
        const payload = { ...this.passwordData, token: localStorage.getItem("token") };
        console.log("Datos que se enviarán a la API:", payload);

        try {
          const resp = await this.postDataWithReturn({ path: "django/portal/change-password/", body: payload });
          this.closePasswordDialog();
        } catch (error) {
          console.error(error);
          alert("Error al cambiar contraseña");
        } finally {
          this.loading = false;
        }
      } else {
        console.log("El formulario no es válido, revisa los campos rojos");
      }
    },
    
    rolPermitido(rolRequerido) {
      return this.permisos.includes(rolRequerido);
      // const rolesGenerales = ["developer", "user", "admin"];
      // return rolesGenerales.includes(this.rol) || this.rol === rolRequerido;
    },

    goToPage(path) {
      const finalPath = path === "/" ? "/" : `/${path}`;
      if (this.$route.path !== finalPath) {
        this.$router.push(finalPath).catch(() => {});
      }
    },

    removeFromCart(item){
      item.in_cart = false;
    },

    logoutFromApp() {
      this.$store.dispatch("logout");
      this.$router.push("/login").catch(() => {});
    },
  }
};
</script>